export const DIRECTION_DANISH_DANISH = "dada";

export const DIRECTION_DANISH_ENGLISH = "daen";
export const DIRECTION_ENGLISH_DANISH = "enda";

export const DIRECTION_DANISH_GERMAN = "dade";
export const DIRECTION_GERMAN_DANISH = "deda";

export const DIRECTION_DANISH_SPANISH = "daes";
export const DIRECTION_SPANISH_DANISH = "esda";

export const DIRECTION_DANISH_FRENCH = "dafr";
export const DIRECTION_FRENCH_DANISH = "frda";

export const DIRECTION_DANISH_ARABIC = "daar";
export const DIRECTION_ARABIC_DANISH = "arda";

export const DIRECTION_DANISH_SWEDISH = "dasv";
export const DIRECTION_SWEDISH_DANISH = "svda";
